import type { SVGProps } from "react";
import { cn } from "@/lib/utils";

type SearchIconProps = SVGProps<SVGSVGElement> & {
	/** Hero search bar mirrors the asset; listing toolbar uses the natural orientation for centering. */
	mirrored?: boolean;
	/** All paths use currentColor (e.g. solid white on the listing toolbar submit button). */
	monochrome?: boolean;
	/** Shift artwork within the viewBox so it centers in square containers (listing toolbar). */
	opticallyCenter?: boolean;
};

export default function SearchIcon({
	className,
	mirrored = true,
	monochrome = false,
	opticallyCenter = false,
	...props
}: SearchIconProps) {
	const accentFill = monochrome ? "currentColor" : "#3fdfcf";

	return (
		<svg
			viewBox="0 0 379.51 379.39"
			xmlns="http://www.w3.org/2000/svg"
			className={cn(mirrored && "origin-center scale-x-[-1]", "block", className)}
			{...props}
		>
			{/* Search icon from techxeed-frontend/public/assets/home/hero/main-search.svg - use currentColor for black parts so it can be controlled via CSS, matching the basket icon logic */}
			<g transform={opticallyCenter ? "translate(-24.25 16.7)" : undefined}>
				{/* Main magnifying glass shape - black parts use currentColor */}
				<path
					d="M150.97,279.76c-.11,1.18-.66,2.16-1.47,3.01-11.86,12.41-24.49,24.47-36.53,36.5-12.37,12.36-48.44,52.29-61.66,57.34-36.04,13.78-66.24-26.73-43.35-57.35l91.74-91.01C49.93,144.58,91.77,34.21,185.17,6.48c114.87-34.1,221.72,71.91,188.03,187.03-27.53,94.08-137.99,136.18-222.24,86.25ZM218.74,17.04c-104.44,7.63-159.69,128.28-97.63,213.03,57.36,78.33,178.24,70.17,225-14.66,51.43-93.3-21.61-206.1-127.37-198.37ZM82.94,268.75c-3.71,3.69-8.27,8.3-12,12-11.11,11.04-22.37,21.97-33.47,33.03-6.53,6.5-19.08,14.65-20.43,24.56-2.55,18.65,15.01,30.18,31.25,21.25,17.45-16.37,33.8-33.89,50.66-50.84,3.98-4,8.02-7.99,12-12,8.87-8.91,18.38-17.29,26.98-26.5-10.48-8.06-21-17.35-28-28.5-9.71,8.25-17.97,18.06-26.98,27Z"
					fill="currentColor"
				/>
				{/* Blue segment on handle */}
				<path
					d="M82.94,268.75l28,28c-3.98,4.01-8.02,8-12,12l-28-28c3.73-3.7,8.29-8.31,12-12Z"
					fill={accentFill}
				/>
				{/* Inner circle outline */}
				<path
					d="M215.73,46.04c118.71-11.42,163.12,143.85,63.23,197.23-83.65,44.7-177.97-34.11-150.52-124.52,11.41-37.59,47.78-68.91,87.29-72.71ZM222.74,62.05c-61.29,4.43-99.5,67.79-74.97,124.38,28.46,65.66,121.62,70.93,157.59,9.25,35.82-61.41-11.62-138.76-82.62-133.62Z"
					fill="currentColor"
				/>
				{/* Three blue dots inside the circle */}
				<path
					d="M181.66,142.94c12.29-2.71,13.7,14.71,3.33,16.39s-13.52-14.15-3.33-16.39Z"
					fill={accentFill}
				/>
				<path
					d="M222.66,142.94c12.29-2.71,13.7,14.71,3.33,16.39s-13.52-14.15-3.33-16.39Z"
					fill={accentFill}
				/>
				<path
					d="M269.66,142.94c12.29-2.71,13.7,14.71,3.33,16.39s-13.52-14.15-3.33-16.39Z"
					fill={accentFill}
				/>
			</g>
		</svg>
	);
}
